export default __webpack_public_path__ + "static/media/edit-offline-payment-icon.267bfaf7.svg";